import React from 'react';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { Container, Box, Typography } from '@mui/material';
import { DynamicsChart } from '/@/app/components/DynamicsChart';
//
import { HelpingDrawerLayout } from '/@/app/views/common/HelpingDrawerLayout';
//
import { TesterViewMenu } from '/@/app/views/TesterView/TesterViewMenu';
import { allSampleData } from '/@/app/views/TesterView/SampleData/AllSampleData';


// pass this to router
export const DynamicsCasesSelect = ({ dataId }) => {
    return (
        <DynamicsCasesBiohacker dataId={dataId} data={allSampleData[dataId]} />
    )
}


export const DynamicsCasesBiohacker = ({ dataId, data }) => {

    //
    // XXX somehow the view won't refresh on allSampleData.data change! FIXME
    //
    return (
        <HelpingDrawerLayout
            drawerContent={TesterViewMenu}
            buttonText="Разделы"
            // customized smaller sidebar
            sidebarWidth={{ xs: "0", lg: "300px" }}
            drawerWidth={{ xs: "100vw", sm: "300px" }}

        >
            <Container maxWidth="sm">
                <Box sx={{
                    pr: {xs: 2, sm: 0},
                    pb: 10,  // keep bottom space for floating bottom panels
                }}>
                    <Typography variant="h2" gutterBottom>Динамика: тест кейс {dataId}</Typography>
                    <Typography variant="body1" gutterBottom>
                        Кейс гипотетического биохакера с множеством анализов.
                        Иногда частые замеры, иногда редкие. Значения случайные, но в правдоподобных диапазонах.
                        Всё в целом должно выглядеть хорошо.
                    </Typography>
                    {Object.entries(data).map(([key, value]) => (
                        <Box key={key}>
                            <Typography variant="h6" sx={{mt: 3}}>{key} - {value.units}</Typography>
                            <DynamicsChart data={value.values} />
                        </Box>
                    ))}

                </Box>
            </Container>
        </HelpingDrawerLayout>
    );
};
